import React from 'react';
import { Activity } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const getActionLabel = (action) => {
  const labels = {
    'login': 'Giriş',
    'logout': 'Çıxış',
    'create_ticket': 'Ticket yaratdı',
    'assign_ticket': 'Ticket təyin etdi',
    'complete_ticket': 'Ticket tamamladı',
    'close_ticket': 'Ticket bağladı',
    'reject_ticket': 'Ticket geri qaytardı',
    'create_user': 'İstifadəçi yaratdı',
    'delete_user': 'İstifadəçi sildi',
    'update_settings': 'Parametrləri yenilədi',
    'create_connection': 'Qoşulma yaratdı',
    'update_connection': 'Qoşulma yenilədi'
  };
  return labels[action] || action;
};

export const AuditLogsPanel = ({ auditLogs = [] }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Activity className="h-5 w-5" />
          Audit Log
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <table className="w-full">
          <thead className="bg-zinc-50">
            <tr>
              <th className="text-left p-4">Tarix</th>
              <th className="text-left p-4">İstifadəçi</th>
              <th className="text-left p-4">Əməliyyat</th>
              <th className="text-left p-4">Detallar</th>
            </tr>
          </thead>
          <tbody>
            {auditLogs.length === 0 ? (
              <tr>
                <td colSpan="4" className="p-4 text-center text-zinc-500">
                  Audit log tapılmadı
                </td>
              </tr>
            ) : (
              auditLogs.map(log => (
                <tr key={log.id} className="border-t">
                  <td className="p-4 text-sm text-zinc-500">
                    {new Date(log.created_at).toLocaleString('az-AZ')}
                  </td>
                  <td className="p-4">{log.username}</td>
                  <td className="p-4">
                    <span className="px-2 py-1 bg-zinc-100 rounded text-sm">
                      {getActionLabel(log.action)}
                    </span>
                  </td>
                  <td className="p-4 text-sm text-zinc-500">
                    {log.details ? JSON.stringify(log.details) : '-'}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
};

export default AuditLogsPanel;
